/** Sentinel for "no category filter" in URL/state (never stored on auction rows). */
export const FILTER_ALL = 'all';

/** Default slugs when API is unavailable (must match server DEFAULT_CATEGORY_SLUGS). */
export const DEFAULT_CATEGORY_SLUGS = [
  'real_estate',
  'vehicles',
  'electronics',
  'furniture',
  'fashion',
  'miscellaneous',
  'donations'
] as const;

/** Arabic / legacy labels and short keys → canonical slug (mirrors server LEGACY_TO_SLUG). */
export const LABEL_TO_SLUG: Record<string, string> = {
  الكل: FILTER_ALL,
  عقارات: 'real_estate',
  سيارات: 'cars',
  ألكترونيات: 'electronics',
  إلكترونيات: 'electronics',
  الكترونيات: 'electronics',
  تكنولوجيا: 'electronics',
  أجهزة: 'electronics',
  أثاث: 'furniture',
  اثاث: 'furniture',
  أزياء: 'fashion',
  منوعات: 'miscellaneous',
  تبرعات: 'donations',
  'قطع غيار وملحقات': 'car_parts',
  'شاحنات ومعدات ثقيلة': 'heavy_equipment',
  دبابات: 'motorcycles',
  'عقار ديل': 'real_estate',
  وظائف: 'jobs',
  خدمات: 'services',
  realestate: 'real_estate',
  cars: 'cars',
  misc: 'miscellaneous'
};

const SLUG_PATTERN = /^[a-z][a-z0-9_]{0,49}$/;

export function isCanonicalCategorySlug(value: string): boolean {
  return SLUG_PATTERN.test(String(value || '').trim().toLowerCase());
}

export function normalizeStoredCategoryToSlug(value: string | undefined | null): string | null {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  if (LABEL_TO_SLUG[raw]) return LABEL_TO_SLUG[raw] === FILTER_ALL ? FILTER_ALL : LABEL_TO_SLUG[raw];
  if (LABEL_TO_SLUG[lower]) return LABEL_TO_SLUG[lower] === FILTER_ALL ? FILTER_ALL : LABEL_TO_SLUG[lower];
  if (SLUG_PATTERN.test(lower)) return lower;
  return null;
}
